module.exports = __webpack_public_path__ + "static/media/mustangsj.b2927296.jpg";